import React from "react";
import { Route } from "react-router-dom";
import Dashboard from "pages/dashboard/Dashboard";
import ParentWithoutStudentList from "pages/parents/ParentWithoutStudentList";
import PersonInChargeWithoutStudentList from "./pages/personInCharges/PersonInChargeWithoutStudentList";
import TotalNoOfAssignments from "./pages/totalNoOfAssignments/TotalNoOfAssignments";
import CalculateCostFeatures from "./pages/calculateCostFeatures/CalculateCostFeatures";
import FindCommercialDocumentFeatures from "./pages/findCommercialDocumentFeatures/FindCommercialDocumentFeatures";
import ExportDataFeatures from "./pages/exportDataFeatures/ExportDataFeatures";

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  // <Route exact path="/reports" render={() => <Reports />} />,
  <Route exact path="/dashboard" render={() => <Dashboard />} />,
  <Route
    exact
    path="/parentsWithoutStudent"
    render={() => <ParentWithoutStudentList />}
  />,
  <Route
    exact
    path="/personInChargesWithoutStudent"
    render={() => <PersonInChargeWithoutStudentList />}
  />,
  <Route
    exact
    path="/totalNoOfAssignments"
    render={() => <TotalNoOfAssignments />}
  />,
  <Route
    exact
    path="/calculateCostFeatures"
    render={() => <CalculateCostFeatures />}
  />,
  <Route
    exact
    path="/findCommercialDocumentFeatures"
    render={() => <FindCommercialDocumentFeatures />}
  />,
  <Route
      exact
      path="/exportDataFeatures"
      render={() => <ExportDataFeatures />}
  />,
];
